<template>
	<div>
		<div class="type-wrap padding-lr padding-top-sm">
			<div class="selected-title flex justify-between">
				<div class="flex align-center">
					<div
						class="selected-step selected-title-all"
						@click="currentComponent = 'structure'"
					>
						所有分类
					</div>
				</div>
				<div
					class="sx-box"
					:class="{opened: opened}"
					@click.stop="opened = !opened"
				>
					<span>{{ opened ? "收起筛选" : "显示筛选" }}</span>
				</div>
			</div>
			<div class="unselected-body" :class="{opened}">
				<!-- <component
				v-bind:is="currentComponent"
				@select="handleSelect"
				:search-param="searchParam"
				:cur-id="id"
				v-on="$listeners"
			></component> -->
				<complex-top
					@select="handleSelect"
					@finishGetList="finishGetList"
					:search-param="searchParamBrand"
					:cur-id="brandId"
					v-on="$listeners"
				></complex-top>
				<Structure
					@select="handleSelect"
					:search-param="searchParam"
					:cur-id="structureId"
					v-on="$listeners"
				>
				</Structure>
			</div>
		</div>
		<div class="dianPuClass">
			<span style="color: #000">店铺</span>
			<span
				style="margin-left: 20px; cursor: pointer"
				v-for="item in queryStoreList"
				:key="index"
			>
				<span
					@click="handQueryStore(item)"
					:class="mctcodeID == item.ID ? 'mctActive' : ''"
					>{{ item.MctName }}</span
				>
			</span>
		</div>
		<div class="type-wrap padding-lr padding-top-sm">
			<div class="selected-title flex justify-between">
				<div class="flex align-center">
					<div
						class="selected-step selected-title-all"
						@click="currentComponent = 'structure'"
					>
						已选
					</div>

					<div
						v-for="item in selectedList"
						:key="item.value"
						class="selected-step"
						@click="handleTitleChange(item)"
					>
						<span class="selected-detail"
							>{{ item.name
							}}<i
								class="el-icon-circle-close"
								style="margin-left: 5px; font-size: 15px; color: #1d2089"
								@click.stop="handleDelete(item)"
							></i
						></span>
					</div>
					<span
						v-if="QueryStoreItem.MctName"
						style="
							display: flex;
							align-items: center;
							font-size: 14px;
							cursor: pointer;
						"
						><span>{{ QueryStoreItem.MctName }} </span>
						<span style="margin-top: 1px"
							><i
								@click="handStoreItem"
								class="el-icon-circle-close"
								style="margin-left: 5px; font-size: 15px; color: #1d2089"
							></i></span
					></span>
				</div>
				<!-- <div
					class="sx-box"
					:class="{openedSelected: openedSelected}"
					@click.stop="openedSelected = !openedSelected"
				>
					<span>{{ openedSelected ? "收起筛选" : "展开筛选" }}</span>
				</div> -->
			</div>
			<div class="unselected-body1" :class="{opened}">
				<!-- <Structure
					@select="handleSelect"
					:search-param="searchParam"
					:cur-id="id"
					v-on="$listeners"
				></Structure> -->
				<Complex
					v-if="searchParam.Name != ''"
					@select="handleSelect"
					:search-param="searchParam"
					:cur-id="id"
					v-on="$listeners"
				></Complex>
			</div>
		</div>
	</div>
</template>
<script>
import Structure from "./structure.vue"
import Complex from "./complex.vue"
import ComplexTop from "./complexTop.vue"
import {
	getQueryItemList,
	GetFromCity,
	getQueryStoreList
} from "@/api/partsShopping.js"

export default {
	// props:{
	// 	queryStoreList:Object
	// },
	inject: ["getStructure", "getList", "getTopBrand", "queryStoreList"],
	data() {
		return {
			selectedList: [],
			notSelectedList: [],
			opened: true,
			currentComponent: "structure",
			//   complexType: "品牌",
			searchParam: {
				Name: "",
				ID: ""
			},
			searchParamBrand: {
				Name: "品牌",
				ID: ""
			},
			id: "",
			mctcodeID: "",
			structureId: "",
			brandId: "",
			queryStoreList: [],
			QueryStoreItem: {}
		}
	},

	created() {
		this.queryStoreList
		// if (Object.values(this.getTopBrand()).length > 0) {
		// 	const {ID, Name} = this.getTopBrand()
		// 	(ID, Name)
		// 	let obj = {
		// 		id: ID,
		// 		name: Name,
		// 		type: "品牌"
		// 	}
		// 	this.currentComponent = "Complex"
		// 	this.handleSelect(obj)
		// }
	},
	computed: {
		structure() {
			this.getStructure()

			return this.getStructure()
		}
	},
	watch: {
		selectedList: {
			handler(val) {
				getQueryStoreList({}).then((res) => {
					this.queryStoreList = res
				})
				// let obj = {
				// 	type: "",
				// 	id: "",
				// 	name: ""
				// }
				// obj.type = val.type
				// obj.name = val.name
				// obj.id = val.value
				// this.handleSelect(obj)
				if (val.length == 0) {
					this.currentComponent = "structure"
				}
			},

			deep: true,
			immediate: true
		},
		structure: {
			handler(val) {
				val
				if (Object.keys(val).length > 0) {
					this.structureId = val.ID || ""
					let index = this.selectedList.findIndex((item) => item.type == "结构")
					const {ID, Name} = val
					let obj = {
						ID: ID,
						name: Name,
						type: "结构"
					}
					if (index >= 0) {
						this.selectedList.splice(index, 1, obj)
					} else this.selectedList.push(obj)
				}
			},
			immediate: true
		}
	},
	components: {
		Structure,
		Complex,
		ComplexTop
	},
	methods: {
		handStoreItem() {
			this.QueryStoreItem = ""
			this.mctcodeID = ""

			this.$emit("getryStoreList", "")
		},
		handQueryStore(e) {
			e
			this.QueryStoreItem = e
			this.mctcodeID = e.ID
			this.$emit("getryStoreList", e)
		},
		disEmpty() {
			this.selectedList = []
			this.searchParam.Name = ""
			this.searchParam.ID = ""
			this.searchParamBrand.Name = "品牌"
			this.searchParamBrand.ID = ""
			this.structureId = ""
			this.id = ""
			this.brandId = ""
		},
		finishGetList(e) {
			// (e)
			if (Object.values(this.getTopBrand()).length > 0 && e == true) {
				const {ID, Name} = this.getTopBrand()(ID, Name)
				let obj = {
					id: ID,
					name: Name,
					type: "品牌"
				}

				this.handleSelect(obj)
			}
		},
		handelSearch() {
			this.selectedList, this.id
			this.selectedList = []

			this.searchParam.Name = ""

			this.id = ""
			;(this.structureId = ""), (this.brandId = "")
		},
		handleSelect(e) {
			e, "handleSelect"
			const {type, id, name} = e(type, id, name)
			if (type == "结构") {
				this.structureId = id
				let index = this.selectedList.findIndex((item) => item.type == type)

				if (index < 0) {
					this.selectedList.push({value: id, name, type: "结构"})
				} else {
					this.selectedList.splice(index, 1, {
						value: id,
						name,
						type: "结构"
					})
				}
				// if (index >= 0) {
				// 	this.selectedList.splice(index, 1, {
				// 		value: id,
				// 		name,
				// 		type: "结构"
				// 	})
				// } else {
				// 	this.selectedList.unshift({value: id, name, type: "结构"})
				// 	(this.selectedList)
				// }
				// if (this.selectedList.find((item) => item.type == "结构")) {
				// 	this.selectedList.splice(0, 1, {value: id, name, type: "结构"})
				// } else {
				// 	this.selectedList.push({value: id, name, type: "结构"})
				// }

				// this.currentComponent = "complex"
			} else {
				let curType = ""
				let searchName = ""
				// 解决点击品牌车系后修改数据
				let index = this.selectedList.findIndex((item) => item.type == type)(
					index
				)

				if (index == 0) {
					e
					this.selectedList[index] = e
					this.handleDelete(e)
				}
				// 解决点击品牌车系后修改数据
				if (type != "车型") {
					if (type == "品牌") {
						this.brandId = id
						searchName = "车系"
					} else if (type == "车系") {
						searchName = "车组"
					} else if (type == "车组") {
						;`1	`
						searchName = "车型"
					}
					let index = this.selectedList.findIndex((item) => item.type == type)
					let structureIndex = this.selectedList.findIndex(
						(item) => item.type == "结构"
					)(index, structureIndex)
					// if (type == "品牌") {
					// 	this.selectedList[index] = e
					// }
					// 结构在前面删除后面的数据
					if (index > 0 && structureIndex < index) {
						this.selectedList.splice(index, this.selectedList.length - index, {
							value: id,
							name,
							type
						})
					}
					//结构在后面删除
					else if (index > 0 && structureIndex > index) {
						this.selectedList.splice(index, structureIndex - index, {
							value: id,
							name,
							type
						})
						let structureIndexEnd = this.selectedList.findIndex(
							(item) => item.type == "结构"
						)
						this.selectedList.splice(
							structureIndexEnd + 1,
							this.selectedList.length - structureIndexEnd
						)
					} else {
						this.selectedList.push({value: id, name, type})
						// (this.selectedList, id)
					}

					this.searchParam = {
						ID: id,
						Name: searchName
					}(this.searchParam)
				} else {
					this.id = id(this.id)
				}
			}
		},
		handleTitleChange(cur, operate) {
			cur, "handleTitleChange"
			const {type, value, name} = cur

			if (type == "结构") {
				// if (operate != "delete") {
				// 	this.currentComponent = "structure"
				// }
				this.structureId = operate == "delete" ? "" : value
				// this.searchParam = {
				// 	ID: "",
				// 	Name: "品牌"
				// }
			}
			// else if (type == "品牌") {
			// }
			else {
				let searchID = ""
				let disPlayName = ""
				let index = 0
				// 	if (type == "品牌") {
				// 	searchID = ""
				// 	disPlayName = "品牌"
				// 	index = 1
				// } else

				if (type == "车系") {
					index = this.selectedList.findIndex((item) => item.type == "品牌")
					let cur = this.selectedList[index]
					searchID = cur.value
					disPlayName = "车系"
				} else if (type == "车组") {
					index = this.selectedList.findIndex((item) => item.type == "车系")
					let cur = this.selectedList[index]
					searchID = cur.value
					disPlayName = "车组"
				}
				this.searchParam = {
					ID: searchID,
					Name: disPlayName
				}

				if (type == "品牌") {
					this.brandId = operate == "delete" ? "" : value
				}
				this.id = operate == "delete" ? "" : value(this.selectedList)

				// if (this.currentComponent != "complex")
				// 	this.currentComponent = "complex"
			}
			this.$emit("getSelectedList", this.selectedList)
		},
		// handleDelete(cur) {
		// 	(cur)
		// 	this.handleTitleChange(cur, "delete")
		// 	(this.selectedList)
		// 	let index = this.selectedList.findIndex((item) => item.value == cur.value)
		// 	let structureIndex = this.selectedList.findIndex(
		// 		(item) => item.type == "结构"
		// 	)
		// 	(structureIndex, index)
		// 	// else if (index == structureIndex) {
		// 	// 	this.selectedList = []
		// 	// 	this.currentComponent = "structure"
		// 	// 	(this.selectedList, 333)
		// 	// }
		// 	// 当车身结构在品牌前面删除点击后面全部
		// 	if (index < structureIndex) {
		// 		(1111111111111)
		// 		this.selectedList.splice(
		// 			index,
		// 			cur.type == "结构" ? 1 : structureIndex - index
		// 		)
		// 	} else if (index <= 0) {
		// 		(222222222)
		// 		this.selectedList.splice(
		// 			index,
		// 			cur.type == "结构" ? 1 : this.selectedList.length - index
		// 		)
		// 		// let obj = {
		// 		// 	Name: "",
		// 		// 	ID: ""
		// 		// }
		// 		// (this.selectedList[this.selectedList.length - 1].name)
		// 		// obj.Name = this.selectedList[this.selectedList.length - 1].name
		// 		// obj.ID = this.selectedList[this.selectedList.length - 1].value
		// 		// this.searchParam = obj
		// 		// (this.selectedList)
		// 	}
		// }
		handleDelete(cur) {
			cur
			this.handleTitleChange(cur, "delete")

			let index = this.selectedList.findIndex((item) => item.value == cur.value)
			let structureIndex = this.selectedList.findIndex(
				(item) => item.type == "结构"
			)
			let complexIndex = this.selectedList.findIndex(
				(item) => item.type == "品牌"
			)(structureIndex, index, complexIndex)
			// debugger
			if (structureIndex == index) {
				this.selectedList.splice(
					index,
					cur.type == "结构" ? 1 : structureIndex - index
				)
			} else if (structureIndex < index) {
				// (33333)
				this.selectedList.splice(
					index,
					this.selectedList.length - structureIndex
				)
			} else if (structureIndex > index) {
				this.selectedList.splice(index, structureIndex - index)

				let structureIndex1 = this.selectedList.findIndex(
					(item) => item.type == "结构"
				)
				this.selectedList.splice(
					structureIndex1 + 1,
					this.selectedList.length - structureIndex1
				)

				// (structureIndex1, this.selectedList.length - structureIndex)

				// (this.selectedList)
				// let structureIndex1 = this.selectedList.findIndex(
				// 	(item) => item.type == "结构"
				// )
				// this.selectedList.splice(
				// 	structureIndex1 + 1,
				// 	this.selectedList.length - structureIndex1
				// )
			}
		}
	}
}
</script>
<style lang="scss" scoped>
.type-wrap {
	border-radius: 10px;
	background: rgba(255, 255, 255, 1);
	border: 1px solid rgba(29, 32, 137, 1);
	margin-top: 40px;

	.selected-title {
		padding-bottom: 10px;

		.selected-title-all {
			cursor: pointer;
			font-size: 16px;
			font-weight: 600;
			color: rgba(35, 35, 35, 1);
		}

		.selected-detail {
			border-radius: 50px;
			background: rgba(254, 118, 72, 1);
			font-size: 12px;
			font-weight: 400;
			color: rgba(255, 255, 255, 1);
			padding: 2px 10px;
			display: flex;
			align-items: center;
			cursor: pointer;
		}

		.selected-step {
			position: relative;
			padding-right: 25px;

			&::after {
				position: absolute;
				font-family: element-icons !important;
				content: "\e6e0";
				font-style: normal;
				font-weight: 600;
				font-variant: normal;
				text-transform: none;
				line-height: 1;
				display: block;
				font-size: 22px;
				color: rgba(35, 35, 35, 1);
				transition: color 0.15s linear;
				top: 50%;
				transform: translateY(-50%);
				right: 0;
			}
		}

		.sx-box {
			cursor: pointer;
			font-size: 16px;
			font-weight: 400;
			color: rgba(35, 35, 35, 1);
			padding-right: 25px;
			position: relative;

			&::after {
				position: absolute;
				font-family: element-icons !important;
				content: "\e6df";
				font-style: normal;
				font-weight: 600;
				font-variant: normal;
				text-transform: none;
				line-height: 1;
				display: block;
				font-size: 22px;
				color: rgba(254, 118, 72, 1);
				transition: color 0.15s linear;
				top: 50%;
				transform: translateY(-50%);
				right: 0;
			}

			&.opened {
				&::after {
					transform: translateY(-50%) rotate(180deg);
				}
			}
		}
	}

	.unselected-body {
		// padding-top: 10px;
		&.opened {
			height: auto;
			opacity: 1;
			border-top: 1px solid rgba(29, 32, 137, 1);

			// padding-top: 10px;
			margin-bottom: 20px;
		}

		height: 0;
		opacity: 0;

		transition: 0.2s cubic-bezier(0.075, 0.82, 0.165, 1);
	}

	.unselected-body1 {
		// padding-top: 10px;
		&.opened {
			height: auto;
			opacity: 1;
			// border-top: 1px solid rgba(29, 32, 137, 1);

			// padding-top: 10px;
			margin-bottom: 20px;
		}

		height: 0;
		opacity: 0;
		transition: 0.2s cubic-bezier(0.075, 0.82, 0.165, 1);
	}
}

.dianPuClass {
	min-height: 50px;
	max-height: auto;
	line-height: 50px;
	border: 1px solid rgba(29, 32, 137, 1);
	background-color: #fff;
	border-radius: 10px;
	padding-left: 30px;
	font-size: 16px;
	margin-top: 15px;
}

.mctActive {
	color: rgba(254, 118, 72);
}
</style>
